import React, { useState, useEffect, useRef } from "react";
import styles from './Select.module.css';

const Select = ({ options, value, disabled, onChange, type }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const selectedOption = options.find((opt) => opt.value === value) || options[0];

  const handleOptionClick = (option) => {
    if (disabled) return;
    setIsOpen(false);
    if (onChange) {
      onChange(option.value); // or option if you need whole object
    }
  };

  const toggleDropdown = () => {
    if (disabled) return;
    setIsOpen(!isOpen);
  };

  return (
    <div className={`${styles["custom-select"]}`} ref={selectRef}>
      <div
        id="selectBox"
        className={`${type ? styles[type] : ''} ${isOpen ? styles["select-active"]:''} ${styles["select-box"]}  ${disabled ? styles.disabled : ''}`}
        onClick={toggleDropdown}
      >
        <div className={`${styles["selected-option"]}  ${isOpen ? styles["select-active"]:''}`}>
          {selectedOption.label}
        </div>
        <div className={`${styles.arrow} ${isOpen ? styles.active : ''}`}>
          <svg xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 24 24"
               width="18"
               height="18"
               fill="gray">
            <path fillRule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.25a.75.75 0 01-1.06 0L5.23 8.27a.75.75 0 01.02-1.06z"
                  clipRule="evenodd" />
          </svg>
        </div>
      </div>

      <div className={`${styles.dropdown} ${isOpen ? styles.active : ''}`}>
        {options.map((option) => (
          <div
            key={option.value}
            className={styles.option}
            onClick={() => handleOptionClick(option)}
          >
            {option.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Select;